<router-outlet appTheme></router-outlet>
<notifier-container></notifier-container>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="medium" color="var(--background-primary)" type="ball-clip-rotate"
    [fullScreen]="true" [zIndex]="9999" [template]="template">
</ngx-spinner>